import api from '../api'; // your Axios instance

interface EditPartnershipRequest {
    id: number;
    text: string;
}

interface EditPartnershipResponse {
    message: string;
    data: {
        id: number;
        right_text: string;
        // Add other business page properties if needed
    };
}

interface UpdatePartnershipImagesResponse {
    message: string;
    data: {
        id: number;
        image?: string;
        mobile_image?: string;
        // Add other business page properties if needed
    };
}

export function getBusinessStory() {
    return api.get('/business/story');
}

export function getBusinessApproach() {
    return api.get('/business/approach');
}

export function getBusinessVision() {
    return api.get('/business/vision');
}

export function getBusinessParterships() {
    return api.get('/business/partnership');
}

export function getBusinessPartnershipImages() {
    return api.get('/business/partnership/images');
}



export function updateBusinessStory(formData: FormData) {
    return api.post('/business/story', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });


}

export function updateBusinessApproach(formData: FormData) {
    return api.post('/business/approach', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });


}

export function updateBusinessVision(formData: FormData) {
    return api.post('/business/vision', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });


}

export function editPartnershipText(data: EditPartnershipRequest) {
    return api.post<EditPartnershipResponse>('/business/partnership/edit-text', data);
}

export function updatePartnershipImages(id: number, image?: File, mobileImage?: File) {
    const formData = new FormData();
    formData.append('id', id.toString());

    if (image) {
        formData.append('image', image);
    }

    if (mobileImage) {
        formData.append('mobile_image', mobileImage);
    }

    return api.post<UpdatePartnershipImagesResponse>('/business/partnership/edit-image', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}
